/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */

export const DEFAULT_LOCALE = "es";

export const appLocales = ["en", "es", "pt", "de", "fr", "it", "pl", "nl"];

export const formatTranslationMessages = async (locale, messages) => {
  let defaultFormattedMessages = {};
  if (locale !== DEFAULT_LOCALE) {
    const esMessages = await import("./locales/es.json");
    defaultFormattedMessages = formatTranslationMessages(DEFAULT_LOCALE, esMessages);
  }

  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };

  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

export const translationMessagesFactory = async (lang) => {
  const [, , translations] = await Promise.all([
    import("@formatjs/intl-relativetimeformat/polyfill"),
    import(`@formatjs/intl-relativetimeformat/dist/locale-data/${lang}`),
    import(`./locales/${lang}.json`),
  ]);
  return formatTranslationMessages(lang, translations[lang]);
};
